module.exports = __webpack_public_path__ + "static/devices@2x-b1265c42ec2d5b10ea93bb23c03469e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/sketch/devices@2x.png
// module id = 447
// module chunks = 131293461488081 145262073310797 281043220932899